// Spiegel van de standaardtekst van een herinneringsmail, voor de preview in
// het venster 'Tekst van de herinnering'. De BRON is
// functions/tasks/buildReminderEmail.js — dát is wat verstuurd wordt.
//
// src/ en functions/ zijn losse npm-pakketten; niets verbindt deze twee bij de
// build en een afwijking is stil. functions/tasks/reminderMailTextParity.test.js
// draait dit bestand in een sandbox en vergelijkt. Faalt die, repareer dan DIT
// bestand, nooit de bron.
// AI-CONTEXT: See docs/patterns.md#data-mirrored-constants
// AI-CONTEXT: See docs/features/bezoekherinnering-eigen-tekst.md
//
// Geen imports: de pariteitstest laadt dit bestand zonder module-lader.

/** Terugval voor het antwoordadres; hetzelfde adres als de Cloud Function gebruikt. */
export const PLATFORM_SENDER = 'info@deccos.nl';

/**
 * Het adres waarop de ontvanger kan reageren, in dezelfde volgorde als de
 * Cloud Function: instelbaar adres, anders onboarding-adres, anders platform.
 *
 * @param {string} [email] - `CompagnyMeta.Email`
 * @param {string} [centralEmail] - `CompagnyMeta.CentralEmail`
 * @returns {string}
 */
export const resolveReplyTo = (email, centralEmail) => email || centralEmail || PLATFORM_SENDER;

/**
 * @param {string} recipientName - '' als er geen naam bekend is
 * @returns {string} "Beste {naam}" of "Beste"
 */
export const reminderGreeting = (recipientName) => (recipientName ? `Beste ${recipientName}` : 'Beste');

/**
 * @param {string} companyName - '' als de organisatie onbekend is
 * @returns {string} "Team {organisatie}" of "Team het team"
 */
export const reminderSignoff = (companyName) => `Team ${companyName || 'het team'}`;

/**
 * De twee alinea's die een eigen tekst vervangt, als platte tekst. De eerste
 * begint met een kleine letter: in de mail volgt hij op "Beste {naam}, ".
 *
 * @param {string} taskTitle - Titel van de afspraak
 * @param {string} companyName - Naam van de organisatie ('' als onbekend)
 * @param {string} replyTo - Adres waarop de ontvanger kan reageren
 * @returns {string}
 */
export const defaultReminderText = (taskTitle, companyName, replyTo) => [
    `bij deze ontvangt u een herinnering van ${taskTitle}${companyName ? ` van ${companyName}` : ''}.`,
    `Kunt u niet aanwezig zijn? Neem dan contact met ons op via ${replyTo}.`,
].join('\n\n');

/**
 * Of een herinnering een eigen tekst heeft. Zelfde regel als de Cloud Function:
 * leeg, alleen witruimte, ontbrekend of geen string telt als 'standaard'.
 *
 * @param {*} value - Wat er in `CustomMessage` staat
 * @returns {boolean}
 */
export const hasCustomMessage = (value) => typeof value === 'string' && value.trim() !== '';

export default defaultReminderText;
